import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getCompanyDPSCount = async (companyID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { count },
  } = await axios.get(`/api/companies/${companyID}/dps/count?${queryString}`);

  return { count };
};

const defaultQueryParams = {
  includeInactive: false,
  expired: false,
  queryOptions: {},
};

export const useCompanyDPSCount = (companyID, queryParams = {}) => {
  const { includeInactive, expired,  queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    includeinactive: includeInactive,
    onlyexpired: expired,
  };
  return useQuery(
    `company-${companyID}-dps-count-${expired}`,
    () => getCompanyDPSCount(companyID, queryStringParams),
    {
      //@ts-ignore
      select: ({ count }) => ({ count }),
      initialData: { count: 0 },
      ...queryOptions,
    }
  );
}